import React, {Component} from 'react';
import {matchRoutes} from 'react-router-config';
import {bindActionCreators} from 'redux';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import _ from 'lodash';
import DomainCommon from "../../../service/common";
import Splash from "../../../main/Splash";
import {routes} from "../../../fuse-configs/fuseRoutesConfig";

let redirect = false;

class FuseAuthorization extends Component {

    constructor(props) {
        super(props);
        this.checkAuth();
    }

    componentDidUpdate(prevProps) {
        /**
         * If route is changed
         * Update auths
         */
        if (!_.isEqual(this.props.location.pathname, prevProps.location.pathname)) {
            this.checkAuth();
        }
    }

    callbackRender() {
        this.setState({reset: true});
    }


    _getGuestCanUseLocations() {
        return routes.map((route) => {
            const isGuestCanUse = ((route.auth || []).length === 0) ? true : route.auth.find((role) => {
                return role === 'guest';
            });
            return {path: route.path, isGuestCanUse};
        }).filter((route) => {
            return route.isGuestCanUse && route.isGuestCanUse !== false;
        });
    }

    _isGuestCanUsePath(guestCanUseLocations) {
        return guestCanUseLocations.find((guestCanUseLocation) => {
            return guestCanUseLocation.path === this.props.location.pathname;
        });
    }

    checkAuth() {
        const matched = matchRoutes(this.props.routes, this.props.location.pathname)[0];
        if (matched && matched.route.auth && matched.route.auth.length > 0) {
            if (!matched.route.auth.includes(this.props.user.role)) {
                redirect = true;
                if (this.props.user.role === 'guest') {
                    this.props.history.push({
                        pathname: '/login',
                        state: {redirectUrl: this.props.location.pathname}
                    });
                }
                else {
                    this.props.history.push({
                        pathname: '/'
                    });
                }
            }
        }
    }

    shouldComponentUpdate(nextProps) {
        if (redirect) {
            redirect = false;
            return false;
        }
        else {
            return true;
        }
    }

    render() {
        const {children} = this.props;

        // const guestCanUseUrls = ['/login'];
        const guestCanUseLocations = this._getGuestCanUseLocations();
        const apiToken = DomainCommon.getApiToken();
        const isGuestCanUsePath = this._isGuestCanUsePath(guestCanUseLocations);

        if (!apiToken && !isGuestCanUsePath) {
            return (<Splash {...this.props} callbackRender={this.callbackRender.bind(this)}/>);
        } else {
            return (
                <React.Fragment>
                    {children}
                </React.Fragment>
            );
        }
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({}, dispatch);
}

function mapStateToProps({fuse, auth}) {
    return {
        user: auth.user
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(FuseAuthorization));



// WEBPACK FOOTER //
// ./src/@fuse/components/FuseAuthorization/FuseAuthorization.js